import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import apiClient from 'shared/api/client.js';

// The proforma signature + stamp images (CLAUDE.md rule #7 — admin-only,
// private storage). GET returns METADATA only (format / hasAlpha /
// dimensions / when), never the bytes; the actual image is loaded straight
// into an <img> from GET /admin/settings/brand-assets/:kind/image, the one
// admin-only path that serves these bytes to a browser.
const KEY = ['admin', 'brandAssets'];

export function useBrandAssets() {
  return useQuery({
    queryKey: KEY,
    queryFn: () => apiClient.get('/admin/settings/brand-assets'),
  });
}

// PUT /admin/settings/brand-assets/:kind — multipart, field "file". Upload
// or replace. The response is the fresh metadata for that one asset.
export function useUploadBrandAsset(kind) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (file) => {
      const formData = new FormData();
      formData.append('file', file);
      return apiClient.put(`/admin/settings/brand-assets/${kind}`, formData);
    },
    onSuccess: (data) => {
      queryClient.setQueryData(KEY, (prev) => ({ ...(prev || {}), [kind]: data.asset }));
    },
  });
}

// DELETE /admin/settings/brand-assets/:kind.
export function useRemoveBrandAsset(kind) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => apiClient.delete(`/admin/settings/brand-assets/${kind}`),
    onSuccess: (data) => {
      queryClient.setQueryData(KEY, (prev) => ({ ...(prev || {}), [kind]: data.asset }));
    },
  });
}
